import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogComponent } from '../components/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})

export class DialogService {

  public ok: boolean = false;
  public cancel: boolean = false;
  private _onSaveFunc: CallableFunction = () => {};
  private _onCancelFunc: CallableFunction = () => {};
  private _onCloseFunc: CallableFunction = () => {};
  private _dialogRef: any;
  private _dialogSub: Subscription;

  constructor(public dialog: MatDialog) {}

  openDialog(headline: string, msg: string, extra: string = '') {
    this.setButtonDefaults();

    const dialogRef = this.dialog.open(
      DialogComponent, {
        data: {
          headline: headline,
          message: msg,
          extra: extra,
        },
        autoFocus: false,
        panelClass: 'dark-dialog-panel'
      }
    );

    this._dialogSub = dialogRef.afterClosed().subscribe((result: any) => {
      if(this.ok) {
        this._onSaveFunc();
      } else if(this.cancel) {
        this._onCancelFunc();
      } else {
        this._onCloseFunc();
      }
    });

    this._dialogRef = dialogRef;

    return dialogRef;
  }

  onSave(cb: CallableFunction) {
    this._onSaveFunc = cb;
  }

  onCancel(cb: CallableFunction) {
    this._onCancelFunc = cb;
  }

  onClose(cb: CallableFunction) {
    this._onCloseFunc = cb;
  }

  setButtonDefaults() {
    this.ok = false;
    this.cancel = false;
  }
}